const MEDIA_ITEMS = [
  {
    id: 1,
    title: '热辣滚烫',
    category: '喜剧·剧情',
    year: '2024',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20warm%20lighting%2C%20Chinese%20comedy%20drama%20film%20poster%20style%2C%20vibrant%20red%20and%20golden%20color%20palette%2C%20soft%20gradient%20background%2C%20cinematic%20atmosphere%2C%20elegant%20composition&width=600&height=340&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '第二十条',
    category: '剧情·律政',
    year: '2024',
    quality: '1080P',
    image: 'https://readdy.ai/api/search-image?query=Legal%20drama%20movie%20atmosphere%20with%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20courtroom%20aesthetic%2C%20film%20poster%20style%2C%20dramatic%20lighting%2C%20elegant%20composition&width=600&height=340&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '飞驰人生2',
    category: '喜剧·运动',
    year: '2024',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=Racing%20movie%20cinematic%20scene%20with%20warm%20sunset%20lighting%2C%20sports%20comedy%20film%20poster%20style%2C%20golden%20and%20orange%20color%20palette%2C%20dusty%20track%20atmosphere%2C%20dramatic%20composition&width=600&height=340&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '繁花',
    category: '年代·商战',
    year: '2024',
    quality: '4K',
    image: 'https://readdy.ai/api/search-image?query=Retro%20Shanghai%20drama%20cinematic%20scene%20with%20warm%20golden%20lighting%2C%201990s%20Chinese%20aesthetic%2C%20film%20poster%20style%2C%20rich%20amber%20and%20crimson%20tones%2C%20elegant%20composition&width=600&height=340&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '与凤行',
    category: '古装·仙侠',
    year: '2024',
    quality: '1080P',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20Chinese%20drama%20cinematic%20scene%20with%20warm%20ethereal%20lighting%2C%20ancient%20costume%20film%20poster%20style%2C%20golden%20and%20coral%20color%20palette%2C%20dreamy%20atmosphere%2C%20elegant%20composition&width=600&height=340&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热门影片推荐
            </h2>
            <p className="text-sm text-foreground-600 max-w-lg mx-auto">
              精选全网热播影视，超清画质免广告，每日更新不重样
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {MEDIA_ITEMS.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-semibold rounded whitespace-nowrap">
                      {item.quality}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <div className="flex items-center gap-2 text-white/80 text-xs mb-1">
                      <span>{item.category}</span>
                      <span>·</span>
                      <span>{item.year}</span>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> 88.5万
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-thumb-up-line"></i> 9.2分
                    </span>
                  </div>
                </div>
              </div>
            ))}
            <div className="sm:col-span-2 lg:col-span-2 flex items-center justify-center p-6 bg-background-100 rounded-xl border border-dashed border-background-300">
              <a
                href="#carousel"
                className="flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部影片 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}